import React from "react";
import IconMamadu from "../../../../assets/img/mamadu/dociekliwosc_dziennikarska_mamadu.svg"

import AttachmentContentBase from "../../../../redesign/components/AttachmentBase";
import { AttachmentElement } from "../../../../components/Article/Parts/Slate/types"


type AttachmentProps = {
    element: AttachmentElement;
};

const AttachmentContent: React.FC<AttachmentProps> = ({
    element,
}) => {

    return (
        <AttachmentContentBase element={element} icon={IconMamadu} />
    );
};

export default AttachmentContent;
